import { render, staticRenderFns } from "./VuetifyMoneyValidate.vue?vue&type=template&id=39987c0e&scoped=true"
import script from "./VuetifyMoneyValidate.vue?vue&type=script&lang=js"
export * from "./VuetifyMoneyValidate.vue?vue&type=script&lang=js"
import style0 from "./VuetifyMoneyValidate.vue?vue&type=style&index=0&id=39987c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39987c0e",
  null
  
)

export default component.exports